module.exports = __webpack_public_path__ + "static/bar_chart_3-9314e50c6bcde1847a6b0b91c05ea7f1.png";